
namespace RioERP.Orders {

    @Serenity.Decorators.registerClass()
    export class EaseBuzzSettingsDialog extends Serenity.EntityDialog<EaseBuzzSettingsRow, any> {
        protected getFormKey() { return EaseBuzzSettingsForm.formKey; }
        protected getIdProperty() { return EaseBuzzSettingsRow.idProperty; }
        protected getLocalTextPrefix() { return EaseBuzzSettingsRow.localTextPrefix; }
        protected getNameProperty() { return EaseBuzzSettingsRow.nameProperty; }
        protected getService() { return EaseBuzzSettingsService.baseUrl; }
        protected getDeletePermission() { return EaseBuzzSettingsRow.deletePermission; }
        protected getInsertPermission() { return EaseBuzzSettingsRow.insertPermission; }
        protected getUpdatePermission() { return EaseBuzzSettingsRow.updatePermission; }

        protected form = new EaseBuzzSettingsForm(this.idPrefix);

    }
}